var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrashSmall = function SvgTrashSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "k844bya6ua",
    d: "M0 0L18 0 18 22 0 22z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-911 -875) translate(527 398) translate(384 477)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "841s52zxwb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k844bya6ua"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.006 20.101c-.018.484-.391.864-.849.864H3.844c-.459 0-.832-.38-.85-.864L2.377 3.11h13.246L15.006 20.1zM7.06 2.073h3.877V1.036H7.061v1.037zm10.449 0h-5.591V1.03c0-.569-.437-1.03-.973-1.03H7.054c-.536 0-.973.461-.973 1.03v1.043H.491C.22 2.073 0 2.304 0 2.59c0 .285.22.518.49.518h.907l.62 17.032C2.054 21.184 2.857 22 3.844 22h10.313c.986 0 1.79-.816 1.827-1.859l.619-17.032h.907c.27 0 .49-.233.49-.518 0-.287-.22-.518-.49-.518z",
    mask: "url(#841s52zxwb)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trashSmall.e453bdd8.svg";
export { ForwardRef as ReactComponent };